import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { HttpClientService, AdobeAnalyticsService, UtilityService } from 'lib/ng2-sapmp/src/providers';

import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { ANALYTICS_CONSTANTS } from 'config';
import { ReCaptcha3Service } from 'lib/ng2-sapmp/src/providers/recaptcha.service';

declare var ENV_PORTAL;
@Injectable()
export class DetailService {

  public site = 'AppMarketPlace';
  private headers;

  constructor(private httpClientService: HttpClientService,
    private utilityService: UtilityService, private adobeAnalyticsService: AdobeAnalyticsService, private recaptcha3Service: ReCaptcha3Service) { }

  getProductDetails(catalogDetailUrl) {
    let headers = this.httpClientService.setCommonHeaders();
    headers = headers.append('Site', this.site);
    headers = headers.delete('Content-Type');
    return this.httpClientService.authorizedGet(catalogDetailUrl, headers)
      .pipe(
       map((res: HttpResponse<any>) => {
        this.httpClientService.updateAuthorizationHeaders(res);
        return res.body;
      })
      ,catchError( this.handleError ));
  }


  getSubscriptionData(subUrl, requestData) {
    return this.httpClientService.authorizedPut(subUrl, requestData)
      .pipe(
       map((res: HttpResponse<any>) => {
        if (sessionStorage.getItem('sapmp_jwtToken') != null) {
          // refreshes token for logged in scenario upon page load
          this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
        }
        return res.body;
      })
      ,catchError( this.handleError ));
  }

  handleError(error) {
    return throwError(error);
  }

  // Page Load
  createPageLoadProperties(skuTiles: any, url: string, title: string) {
    const dataLayer = {};
    const removeProductId = url.substring(0, url.lastIndexOf('/'));
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LOCATION_URL] = ANALYTICS_CONSTANTS.ENVIRONMENT_URL + removeProductId;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS.FRIENDLY_NAME_DETAILS;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_SHOP;
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
    let sku;
    if (skuTiles) {
      for (const skuObject of skuTiles) {
        sku = (sku === undefined) ? skuObject.socCode : sku + '|' + skuObject.socCode;
      }
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SKU] = sku;
    }
    if (sessionStorage.getItem('sapmp_jwtToken') != null) {
      dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';
      if (ENV_PORTAL === 'fnabc') {
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRSTNET_FLAG] = ANALYTICS_CONSTANTS.EVENTS_SUCCESSFLAG_1;
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE] = ANALYTICS_CONSTANTS.GLOBAL_USER_FIRST_NET_USER_ROLE_VALUE;
      }
    }
    dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Sales';
    this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
  }

  // postForm(form: any): any {
  //   return this.httpClientService.post(this.utilityService.getEnvConfig().notificationServiceForm, form).pipe(
  //     map((res: HttpResponse<any>) => {
  //     return res.body;
  //   }),catchError(this.handleError));
  // }

  postForm(form: any): any {
    return this.recaptcha3Service.getToken().then(
      (token: any) => {
        this.headers = new HttpHeaders({
          'captcha-authenticate': token
        });
        return this.httpClientService.post(this.utilityService.getEnvConfig().notificationServiceForm, form, this.headers).pipe(
              map((res: HttpResponse<any>) => {
              return res.body;
            }),catchError(this.handleError));
      }
    )

  }

}
